import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Leaf, Coffee, ShoppingCart, FileText, Gift } from 'lucide-react';
const items = [{
  icon: Leaf,
  emoji: '🌿',
  title: 'Guía Maestra S.O.S.',
  description: 'El protocolo botánico de 15 minutos para calmar tu sistema nervioso antes de dormir.',
  value: '$37 USD'
}, {
  icon: Coffee,
  emoji: '🍵',
  title: 'Recetario de 7 Elixires Calmantes',
  description: '7 infusiones con dosis exacta para bajar la actividad mental por la noche.',
  value: '$27 USD'
}, {
  icon: ShoppingCart,
  emoji: '🛒',
  title: 'Checklist del Botiquín Calmante',
  description: 'La lista de plantas que necesitas para tener siempre tu protocolo listo..',
  value: '$17 USD'
}, {
  icon: FileText,
  emoji: '📄',
  title: 'Hoja de Vaciado Mental',
  description: 'Ejercicio guiado de 3 minutos para vaciar la mente antes de dormir.',
  value: '$17 USD',
  isBonus: true
}];
export function PackageSummary() {
  return <section className="px-6 py-5 max-w-3xl mx-auto" data-id="element-406">
      <FadeIn data-id="element-407">
        <div className="text-center mb-8" data-id="element-408">
          <p className="text-lg md:text-xl text-[#2D2A26]/80 font-serif italic leading-relaxed mb-6" data-id="element-409">
            Hoy no recibes solo un ebook. Recibes el protocolo completo para
            aplicar el método en casa.
          </p>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#4A5D3A]" data-id="element-410">
            TODO LO QUE RECIBES POR{' '}
            <span className="text-[#9B4F2B]" data-id="element-411">$6.39 USD</span>:
          </h2>
        </div>
      </FadeIn>

      <div className="space-y-4" data-id="element-412">
        {items.map((item, index) => <FadeIn key={index} delay={index * 0.08} data-id="element-413">
            <div className={`relative bg-white rounded-2xl p-5 md:p-6 border ${item.isBonus ? 'border-[#C4A265]/40 bg-[#C4A265]/5' : 'border-[#4A5D3A]/10'} shadow-sm`} data-id="element-414">
              {item.isBonus && <div className="absolute -top-3 left-5" data-id="element-415"></div>}

              <div className="flex items-start gap-4" data-id="element-416">
                <div className="text-2xl md:text-3xl shrink-0 mt-0.5" data-id="element-417">
                  {item.emoji}
                </div>
                <div className="flex-1 min-w-0" data-id="element-418">
                  <div className="flex items-start justify-between gap-3" data-id="element-419">
                    <h3 className="font-bold text-lg md:text-xl text-[#2D2A26]" data-id="element-420">
                      {item.title}
                    </h3>
                    <span className="shrink-0 text-sm font-bold text-[#4A5D3A] bg-[#4A5D3A]/10 px-3 py-1 rounded-full whitespace-nowrap" data-id="element-421">
                      {item.value}
                    </span>
                  </div>
                  <p className="text-[#2D2A26]/70 text-sm md:text-base leading-relaxed mt-2" data-id="element-422">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} data-id="element-423">
        <p className="text-center text-lg md:text-xl font-serif italic text-[#4A5D3A] mt-10 leading-relaxed" data-id="element-424">
          Todo diseñado para ayudarte a apagar el ruido mental y volver al
          descanso.
        </p>
      </FadeIn>
    </section>;
}